module.exports = __webpack_public_path__ + "static/media/logoHeaderInv.7bd03ba5.svg";